var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.974,
    height: 13.946,
    viewBox: "0 0 13.974 13.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4595858561536572526_1_",
    "data-name": "4595858561536572526 (1)",
    d: "M13.66,12.117,8.5,6.959l5.13-5.13A1.072,1.072,0,0,0,12.116.314l-5.13,5.13L1.857.314A1.072,1.072,0,0,0,.342,1.829l5.129,5.13L.313,12.117a1.072,1.072,0,0,0,1.516,1.515L6.987,8.474l5.158,5.158a1.072,1.072,0,1,0,1.515-1.515Z",
    transform: "translate(0 0)",
    fill: "#f44336"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMenu);
export default __webpack_public_path__ + "static/media/delete-menu.6d2287d4ec3cc86ef8a3c8a559514556.svg";
export { ForwardRef as ReactComponent };